import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GroupError, GroupMessage } from '@/exceptions/group/group.enum';
import { groupService } from '@/services/group.service';
import { notificationService } from '@/services/notification.service';

const useDeleteGroup = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (groupId: string) =>
			await groupService.deleteGroup(groupId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['group'] });
			notificationService.success(GroupMessage.DELETED_GROUP_MESSAGE);
		},

		onError: () => {
			notificationService.error(GroupError.DELETE_ERROR);
			throw new Error(GroupError.DELETE_ERROR);
		},
	});
};

export default useDeleteGroup;
